export default "__VITE_ASSET__D8vW$Pp5__"